import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    position: 'relative',
    margin: 4,
    width: 100,
    height: 100,
    borderRadius: 6,
    overflow: 'hidden',
    border: 'solid 0.5px rgba(0, 0, 0, 0.06)',
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  backdrop: {
    borderStyle: 'solid',
    borderRadius: 4.5,
    borderWidth: 3,
    borderColor: theme.palette.primary.main,
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    width: '100%',
    height: '100%',
    zIndex: 1,
  },
  reviewed: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    backgroundColor: 'rgba(170, 170, 170, 0.4)',
  },
  reviewText: {
    position: 'absolute',
    fontSize: 12,
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#fff',
    width: '100%',
    height: 24,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    zIndex: 1,
    left: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  blocked: {
    backgroundColor: theme.palette.secondary.main,
  },
  pending: {
    backgroundColor: '#222222',
  },
  approve: {
    backgroundColor: theme.palette.primary.main,
  },
  imageButton: {
    padding: 0,
    border: '0 none',
    borderRadius: 0,
  },
  image: {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    transition: theme.transitions.create('opacity', { duration: 300 }),
    opacity: 0,
  },
  loaded: {
    opacity: 1,
  },
  checkbox: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    padding: 6,
  },
  lightCheckbox: {
    color: '#fff',
  },
  darkCheckbox: {
    color: '#333',
  },
}));

export default useStyles;
